import join from 'url-join';
import { getENV } from './env';

export function getPetsmartUrl() {
    const {
        NEXT_PUBLIC_LOCALE: locale,
        VELOCITY_CA_HOST_DOMAIN,
        VELOCITY_US_HOST_DOMAIN,
    } = getENV();

    const hosts = {
        'en-US': VELOCITY_US_HOST_DOMAIN,
        'en-CA': VELOCITY_CA_HOST_DOMAIN,
    };

    return join('https://', hosts[locale]);
}
